"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Command = exports.BasicTooltip = exports.Tooltip = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var portal_1 = require("../../hooks/portal");
var theme_1 = require("../../theme");
var colors_1 = require("../../theme/colors");
var box_1 = require("../box");
var flexbox_1 = require("../flexbox");
var icons_1 = require("../icons");
var padding_1 = require("../padding");
var popover_animation_1 = require("../popover-animation");
var tether_1 = require("../tether");
var text_1 = require("../text");
var POSITION_MAPPING = {
    bottom: {
        targetAnchor: 'bottom',
        anchor: 'top',
        yOffset: 10,
        xOffset: 0,
        animationDirection: 'down',
    },
    top: {
        targetAnchor: 'top',
        anchor: 'bottom',
        yOffset: -10,
        xOffset: 0,
        animationDirection: 'up',
    },
    right: {
        targetAnchor: 'right',
        anchor: 'left',
        yOffset: 0,
        xOffset: 10,
        animationDirection: 'right',
    },
    left: {
        targetAnchor: 'left',
        anchor: 'right',
        yOffset: 0,
        xOffset: -10,
        animationDirection: 'left',
    },
};
function Tooltip(props) {
    var children = props.children, text = props.text, customElement = props.customElement, message = props.message, _a = props.followMouse, followMouse = _a === void 0 ? false : _a, testId = props.testId, tipTestId = props.tipTestId, _b = props.positionTip, positionTip = _b === void 0 ? 'right' : _b, style = props.style;
    var targetRef = (0, react_1.useRef)();
    var popoverRef = (0, react_1.useRef)();
    var _c = (0, react_1.useState)(false), isOpen = _c[0], setOpen = _c[1];
    var _d = (0, react_1.useState)({ x: 0, y: 0 }), tooltipPosition = _d[0], setTooltipPosition = _d[1];
    if (!text && !message && !customElement) {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    var _e = POSITION_MAPPING[positionTip], anchor = _e.anchor, targetAnchor = _e.targetAnchor, xOffset = _e.xOffset, yOffset = _e.yOffset, animationDirection = _e.animationDirection;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledChildren, { "data-testid": testId, role: "button", tabIndex: 0, onFocus: function () { return setOpen(true); }, onMouseOver: function () { return setOpen(true); }, onMouseOut: function () { return setOpen(false); }, onMouseMove: function (e) {
                setTooltipPosition({ x: e.clientX, y: e.clientY });
            }, onBlur: function () { return setOpen(false); }, style: style, ref: !followMouse ? targetRef : undefined }, children),
        followMouse && (react_1.default.createElement("div", { style: { top: tooltipPosition.y + yOffset, left: tooltipPosition.x + xOffset, position: 'fixed' }, ref: targetRef },
            react_1.default.createElement(react_1.default.Fragment, null))),
        react_1.default.createElement(portal_1.Portal, { name: "tooltip" },
            react_1.default.createElement(tether_1.Tether, { targetRef: targetRef, targetAnchor: targetAnchor, anchor: anchor, yOffset: yOffset, xOffset: xOffset, zIndex: theme_1.zIndices.tooltip },
                react_1.default.createElement(popover_animation_1.PopoverAnimation, { isOpen: isOpen, direction: animationDirection },
                    react_1.default.createElement("div", { ref: popoverRef, "data-testid": tipTestId }, getContent(props)))))));
}
exports.Tooltip = Tooltip;
function getContent(props) {
    var text = props.text, command = props.command, message = props.message, customElement = props.customElement, variant = props.variant, maxWidth = props.maxWidth;
    if (text) {
        return (react_1.default.createElement(BasicTooltip, { command: command, variant: variant, maxWidth: maxWidth }, text));
    }
    if (message) {
        return (react_1.default.createElement(BasicTooltip, { command: command, variant: variant, maxWidth: maxWidth }, message));
    }
    return customElement;
}
function BasicTooltip(props) {
    var children = props.children, command = props.command, _a = props.maxWidth, maxWidth = _a === void 0 ? 500 : _a, variant = props.variant;
    return (react_1.default.createElement(box_1.Box, { borderRadius: 6, backgroundColor: colors_1.colors.steel[500], style: { pointerEvents: 'none', maxWidth: maxWidth }, boxShadow: "overlay" },
        react_1.default.createElement(padding_1.Padding, { size: 8 },
            react_1.default.createElement(flexbox_1.Flexbox, { alignItems: "center", gap: 8 },
                variant ? (react_1.default.createElement(box_1.Box, { style: { flexShrink: 0 } }, variant === 'info' ? react_1.default.createElement(icons_1.IconCircleInformation, { size: 16, color: "white" }) : null)) : null,
                react_1.default.createElement(text_1.Text, { color: "white" }, children),
                command ? react_1.default.createElement(exports.Command, null, command) : null))));
}
exports.BasicTooltip = BasicTooltip;
var StyledChildren = styled_components_1.default.span(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  cursor: pointer;\n  position: relative;\n\n  &:focus {\n    outline: 1px dashed ", ";\n  }\n"], ["\n  cursor: pointer;\n  position: relative;\n\n  &:focus {\n    outline: 1px dashed ", ";\n  }\n"])), colors_1.colors.steel[200]);
exports.Command = styled_components_1.default.div(templateObject_2 || (templateObject_2 = (0, tslib_1.__makeTemplateObject)(["\n  display: inline-block;\n  font-family: monospace;\n  background: #546a83;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 2px;\n  line-height: 1;\n  font-size: ", ";\n"], ["\n  display: inline-block;\n  font-family: monospace;\n  background: #546a83;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 2px;\n  line-height: 1;\n  font-size: ", ";\n"])), theme_1.fontSizes.small.fontSize);
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map